import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { fetchTreatments,getOngoingTreatmentsCount,getPendingTreatmentsCount} from '../../../actions/addTreatments';
import { fetchMedicalRecords,getTotalMedicalRecordsCount} from '../../../actions/medicalRecords';
import { fetchContracts,getTotalContractCount,getCurrentYearContractsInfo,getLastWeekContractsInfo,getMonthlyContractInfo,getContractsViaCustomerState} from '../../../actions/contracts';
import { getCurrentPetShop } from "../../../actions/petShop";
import { fetchUserLogins} from '../../../actions/user'
import { NavLink } from 'react-router-dom';
import _ from 'lodash';
import ViewTreatment from '../../treatments/treatments/viewTreatment';
import { NotificationManager } from 'react-notifications';
import { forceInputUppercase, } from "../../../utils/helper";
import { sendEmailCustomer,fetchVerifyEmail} from '../../../actions/customers';
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import filterFactory, {
  textFilter,
  selectFilter
} from "react-bootstrap-table2-filter";
import Select from "react-select";
import { Loader } from "../../../components/loader";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import moment from 'moment';
import config from "../../../config";
const $ = window.$;

const BarChart = require("react-chartjs").Bar;

const intialState = {
    mRecCount:0,
    contCount:0,
    pTreatments:0,
    oTreatments:0,
    trmntsOnGoing:[],
    trmntsPending:[],
    mRecords:[],
    allmRecords:[],
    contracts:[],
    treatId:'',
    chartOptions: {
        responsive: true,
        legend: {
            position: 'top',
        },
        title: {
            display: true,
            text: 'Total sales from 2018-04-10 to 2018-05-10'
        },    
    },
    userLogins:[],
    petId:"",
    email:"",
    validateFlag:false,
    verifyEmail:[],
    verifyEmailId:"",
    successEmail:false,
    salesSelectOption : [],
    customersStatesTableSelectOptions : [{ label:"All Time", value:"all", startDate:"all"}],    
    monthlyCount:0,
    monthlyTax:0,
    monthlyTotal:0,
    monthlyCDTotal:0,
    monthlyCashTotal:0,   
    monthlyOtherTotal:0,
    monthlyFinanceTotal:0,
    chartmonthlyData:{
        labels: [],
        datasets: [{
            label: 'Total (USD)',
            fillColor: "rgb(255, 177, 193,0.5)",
            strokeColor: "rgb(255, 177, 193)",
            highlightFill: "rgb(255, 177, 193,0.5)",
            highlightStroke: "rgb(255, 177, 193)",
            borderWidth: 1,
            data: [],         
        },
    ]

    }, 
    ContractsViaCustomersState:[],
    ContractsAllDataViaCustomersState:[],
    loadingContractViaStateTable: false,
    enableMoreText : false,
    monthlyDataLoading : false,
    saleTitle:"",
}

class AdminDashboard extends Component {
    constructor(props) {
        super(props);
        this.state = intialState;
    }
    paymentType = {        
        credit_debit : "credit_debit",
        other: "other",
        cash: "Cash",
        finance: "Financing",  
        american_express: "American Express",
        discover : "DISCOVER"  
    };
    contractInfoLimitation = 5;
    tableHeaderColumnData = [     
        {
          dataField: "state",
          text: "State",
          sort: true
        },
        {
          dataField: "contractCount",
          text: "Count",
          sort: true,
          formatter: cell => cell
    }];
    viewTreatment(tId) {
        this.setState({treatId: tId})
        $('#view_treatment').modal('show');
    }
    changeVal = event => {      
        forceInputUppercase(event);    
        let value = event.target.value;    
        if (event.target.name === 'petId'){
        value = value.split(" ").join("");
        }          
        this.setState({
          ...this.state,
          [event.target.name]: value
        });
       
      };
    changeEmailType = selected => {      
        if (selected) {
          this.setState({ verifyEmailId: selected.value });
        }
      }
    sendEmail(){
      let mailArry = [];    
      mailArry = this.state.email ? this.state.email.split(','):[];
      let validEmail = this.validateEmailList(mailArry);
      if(validEmail && mailArry && mailArry.length > 0 && this.state.petId ) {   
      let mailObject ={
          petId: this.state.petId,
          from: this.state.verifyEmailId,
          email: mailArry,
          base_url: process.env.REACT_APP_API_ENDPOINT
      };      
      this.props.sendEmailCustomer(mailObject);
      }
      else{
        if(!validEmail){
        NotificationManager.error("Please enter a valid email address.");    
        }
        else{  
        NotificationManager.error("Please check input details again.");
        this.setState({validateFlag:true});
        }
      } 

    }
    validateEmailList(emails){    
        var valid = true;
        var regex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        for (var i = 0; i < emails.length; i++) {
            if( emails[i] === "" || !regex.test(emails[i].replace(/\s/g, ""))){
                valid = false;
            }
        }
        return valid;
    }
    changeSalesOption = (selected)=>{     
        if (selected) {
            this.setState({ saleSelectedOption: selected.value ,monthlyDataLoading : true, saleTitle : selected.title });
            this.props.getMonthlyContractInfo(selected.startDate);
          }
    };
    changeCustomersStateSelectOption = (selected)=>{
        if (selected) {
            this.setState({ customerSelectOption: selected.value, loadingContractViaStateTable: true });
            this.props.getContractsViaCustomerState(selected.startDate);
          }
    };
    loadSalesInfo =  () => {
        let monthArray = [];    
        const startOfMonth = moment().startOf('month').format('YYYY-MM-DD');    
        const currentMonthStartDate = moment().startOf('month').format('MMM-YYYY');    
        const defaulltSaleTitle = `${moment().format('MMMM')} ${moment().format('YYYY')}`;    
        let customerStateCurrentData = this.state.customersStatesTableSelectOptions;
        for(let i = 0; i<= 12 ; i++){
            let monthFormat1 = moment().subtract(i, 'months').format('MM');
            let monthFormat2 = moment().subtract(i, 'months').format('MMM');
            let monthFormat3 = moment().subtract(i, 'months').format('YYYY');
            let monthFormat4 = moment().subtract(i, 'months').format('MMMM');
            monthArray.push({
                label : `${monthFormat4} ${monthFormat3}`,
                value : `${monthFormat2}-${monthFormat3}`,
                title : `${monthFormat4} ${monthFormat3}`,
                startDate : `${monthFormat3}-${monthFormat1}-01`,          
            });    
       }
       let fullCustomersStateOptions = monthArray.concat(customerStateCurrentData);
       this.setState({ salesSelectOption : monthArray, saleSelectedOption : currentMonthStartDate, monthlyDataLoading : true, saleTitle : defaulltSaleTitle, customersStatesTableSelectOptions : fullCustomersStateOptions });
       this.props.getMonthlyContractInfo(startOfMonth);
    }

    resetState = () =>{
       const chartmonthlyData = {
            labels: ['Week1','Week2','Week3','Week4'],
            datasets: [{
                label: 'Total (USD)',
                fillColor: "rgb(255, 177, 193,0.5)",
                strokeColor: "rgb(255, 177, 193)",
                highlightFill: "rgb(255, 177, 193,0.5)",
                highlightStroke: "rgb(255, 177, 193)",
                borderWidth: 1,
                data: [0,0,0,0],         
            },    
        ]
    
        }
        this.setState({
            monthlyCount:0,
            monthlyTax:0,
            monthlyTotal:0,
            monthlyCDTotal:0,
            monthlyCashTotal:0,   
            monthlyOtherTotal:0,
            monthlyFinanceTotal:0,  
            chartmonthlyData: chartmonthlyData,
            monthlyDataLoading : false,
        });

    }
    formatCash = n => {
        if (n < 1e3) return n;
        if (n >= 1e3 && n < 1e6) return +(n / 1e3).toFixed(1) + "K";
        if (n >= 1e6 && n < 1e9) return +(n / 1e6).toFixed(1) + "M";
        if (n >= 1e9 && n < 1e12) return +(n / 1e9).toFixed(1) + "B";
        if (n >= 1e12) return +(n / 1e12).toFixed(1) + "T";
    };  

    componentDidMount() {
        this.props.fetchUserLogins();
        this.props.fetchTreatments();
        this.props.fetchMedicalRecords();
        this.props.fetchContracts();
        this.props.getTotalMedicalRecordsCount();
        this.props.getTotalContractCount();
        this.props.getOngoingTreatmentsCount();
        this.props.getPendingTreatmentsCount();      
        this.props.fetchVerifyEmail();
        this.props.getLastWeekContractsInfo(); 
        this.loadSalesInfo();

        
    }
    componentWillReceiveProps = (nextProps) => {
        // if(nextProps.treatmentError||nextProps.mRecordsError||nextProps.mRecordCountError||nextProps.contractCountError||nextProps.ongoingTreatCountError||nextProps.pendingTreatCount||nextProps.contractsError||nextProps.conCountError||nextProps.contractInfoError||nextProps.userLoginsError){
        //     NotificationManager.error('Something went wrong!')
        // }
        if(this.props.userLogins !== nextProps.userLogins){
            this.setState({userLogins:nextProps.userLogins});
        }

        if(this.props.pendingTreatments !== nextProps.pendingTreatments || this.props.pendingTreatments !== this.state.pTreatments){
            this.setState({pTreatments:nextProps.pendingTreatments});
            
        }
        if(this.props.ongoingTreatments !== nextProps.ongoingTreatments || this.props.ongoingTreatments !== this.state.oTreatments){
            this.setState({oTreatments:nextProps.ongoingTreatments});
            
        }
        if(this.props.mRecordCount !== nextProps.mRecordCount || this.props.mRecordCount !== this.state.mRecCount){
            this.setState({mRecCount:nextProps.mRecordCount});
            
        }
        if(this.props.contractCount !== nextProps.contractCount || this.props.contractCount !== this.state.contCount){
            this.setState({contCount:nextProps.contractCount});
        }
        
        if ( this.props.treatments !== nextProps.treatments) {
            let trtPending = nextProps.treatments.filter(m => m.status==='Pending').sort((a,b)=>{return a.daysLeft - b.daysLeft}).slice(0,5);
            let trtInprogress = nextProps.treatments.filter(m => m.status==='In progress').sort((a,b)=>{return a.daysLeft - b.daysLeft}).slice(0,5);
            this.setState({ trmntsPending: trtPending, trmntsOnGoing: trtInprogress });
        }
        if(nextProps.mRecords && nextProps.mRecords.medicalRecords && nextProps.mRecords.medicalRecords.length > 0 && this.props.mRecords.medicalRecords !== nextProps.mRecords.medicalRecords){
            let allMRecords = nextProps.mRecords.medicalRecords;
            let mRecords = allMRecords.sort((a,b)=>{return moment().diff( a.createdAt, 'days') - moment().diff( b.createdAt, 'days')}).slice(0,5);
            this.setState({ mRecords: mRecords, allmRecords: allMRecords}); 
        }
        if(nextProps.contracts && nextProps.contracts.contractRecords && nextProps.contracts.contractRecords.length > 0 && this.props.contracts.contractRecords !== nextProps.contracts.contractRecords){
            let allContract = nextProps.contracts.contractRecords;
            let cts = allContract.sort((a,b)=>{return moment().diff( a.createdAt, 'days') - moment().diff( b.createdAt, 'days')}).slice(0,5);
            this.setState({ contracts: cts}); 
        }
        if (this.props.customerEmail !== nextProps.customerEmail) {  
            NotificationManager.success(nextProps.customerEmail.message);
            this.setState({ petId:"",email:"",verifyEmailId:"" });        
            
        }  
        if (this.props.customerEmailErr !== nextProps.customerEmailErr) {  
             NotificationManager.error("Medical record not found");          
        } 
        if (
            nextProps.verifyEmailList &&
            this.props.verifyEmailList !== nextProps.verifyEmailList &&
            nextProps.verifyEmailList.length > 0
          ) {
            let options = [{ label: "Select Email", value: null }];
            nextProps.verifyEmailList.map(p => {
              options.push({ label: p.email, value: p.email });
            });
            this.setState({ verifyEmail: options });
            if (nextProps.verifyEmailList.length > 0) {
              this.setState({ verifyEmailId: null });
            }
        }
    
        if(this.props.contractLastMonthInfo !== nextProps.contractLastMonthInfo){
            let thisMonthContractInfo = nextProps.contractLastMonthInfo;  
            const financingMethods = config.financingPaymentMethods;        
            if( thisMonthContractInfo && thisMonthContractInfo.length > 0 ){      
                let chartmonthlyData = Object.assign({}, this.state.chartmonthlyData); 
                let yAxisContractTotal = [];
                let yAxisContractCount = [];
                let xAxis = [];
                let collectedContracts = [];         
                thisMonthContractInfo.map(item => {       
                xAxis.push(`Week${item.weekCount}`);                
                if(item.contracts){
                    yAxisContractCount.push(item.contracts.length); 
                    collectedContracts.push(item.contracts);
                    let subCon = item.contracts;
                    let total = 0;
                    subCon.map(c =>{
                        total = total + parseFloat(c.total);
                    });
                    yAxisContractTotal.push(total);   
                }    
                });   
                chartmonthlyData.datasets[0].data = yAxisContractTotal;          
                chartmonthlyData.labels =  xAxis;         
                this.setState({chartmonthlyData, monthlyDataLoading: false,});        
                if(collectedContracts && collectedContracts.length > 0){
                    let allCollectedContracts = collectedContracts.reduce((a, b) => a.concat(b), []);              
                    let total = 0,tax = 0,cash = 0,cb = 0,cfl = 0, other = 0;
                    allCollectedContracts.map(c=>{
                        if(c.total){                  
                            total = total + parseFloat(c.total);                
                        }
                        if(c.tax){       
                            tax = tax + parseFloat(c.tax);                   
                        }
                        if(c.ContractPayments){
                            c.ContractPayments.map(p=>{   
                                const indexOfFinancingMethod = p.PaymentType ?  financingMethods.indexOf(p.PaymentType.payment_type) : -1;                                            
                                if((p.method === this.paymentType.credit_debit && p.PaymentType === null) || ( p.PaymentType && p.PaymentType.payment_type && p.PaymentType.payment_type === this.paymentType.american_express) || ( p.PaymentType && p.PaymentType.payment_type && p.PaymentType.payment_type === this.paymentType.discover)){                    
                                    cb = cb + parseFloat(p.amount);                                 
                                }else if( p.method === this.paymentType.other && p.PaymentType &&  p.PaymentType.payment_type && p.PaymentType.payment_type === this.paymentType.cash ){                  
                                    cash = cash + parseFloat(p.amount);                                  
                                }else if(p.method === this.paymentType.other && indexOfFinancingMethod >=0 ){                             
                                    cfl = cfl + parseFloat(p.amount); 
                                }else{                       
                                    NotificationManager.error(`Unrecognized Payment method ${p.PaymentType.payment_type}`);                       
                                }                   
                                                             
                      
                            }); 
                        }
                    });    
                    this.setState({monthlyTotal: total, monthlyTax: tax, monthlyCount: allCollectedContracts.length, monthlyCDTotal: cb, monthlyFinanceTotal:cfl,
                         monthlyOtherTotal : other, monthlyCashTotal : cash, });
                }
            }else{
                   this.resetState();
            }
        }
        if(this.props.contractsViaCustomerState !== nextProps.contractsViaCustomerState){
            const data =  nextProps.contractsViaCustomerState;       
            const limitContractsInfoIndex = this.contractInfoLimitation - 1;
            let limitedContractsViaCustomerState = [] ;
            let enableMoreText = false;
            for(const contractsIndex in data){         
                    if(contractsIndex <= limitContractsInfoIndex){
                        limitedContractsViaCustomerState.push(data[contractsIndex]);
                    }
                    else{
                        enableMoreText = true;
                    }
            } 
          this.setState({ContractsViaCustomersState : limitedContractsViaCustomerState, ContractsAllDataViaCustomersState: data, loadingContractViaStateTable : false, enableMoreText : enableMoreText });
        }
        if(nextProps.contractLastMonthInfoError && this.props.contractLastMonthInfoError !== nextProps.contractLastMonthInfoError){
            NotificationManager.error("An error occurred while loading the Last month contracts"); 
        }
        if( nextProps.contractLastWeekInfoError && this.props.contractLastWeekInfoError !== nextProps.contractLastWeekInfoError){    
            NotificationManager.error("An error occurred while loading the Last week contracts");             
        }
        if( nextProps.contractsViaCustomerStateError && this.props.contractsViaCustomerStateError !== nextProps.contractsViaCustomerStateError){        
            NotificationManager.error("An error occurred while loading the Contract information"); 
        }
    }
    
    navigationMR(y){    
    let data = this.state.allmRecords;
    let index = _.findIndex(data, {id: y.id});
    let previndex = (index == 0) ? null : (index - 1);
    let nextindex = index + 1;
    let prevEle = nextindex != null ? data[nextindex] ? data[nextindex].id : null : null;
    let nextEle = previndex != null ? data[previndex] ? data[previndex].id : -1 : -1; 
    let path = `/medical-records/${y.id}/${prevEle}/${nextEle}`
    this.props.history.push(path)
    
    }
    render() {
        const {userLogins, chartOptions, trmntsOnGoing, trmntsPending, treatId, contracts, mRecords,mRecCount,contCount,pTreatments,oTreatments,verifyEmail,verifyEmailId,petId,email,chartmonthlyData,monthlyTotal,monthlyTax,monthlyCount,monthlyFinanceTotal,monthlyCashTotal, monthlyCDTotal,ContractsViaCustomersState,ContractsAllDataViaCustomersState,loadingContractViaStateTable,enableMoreText,monthlyDataLoading,saleTitle} = this.state;
       
        const { petShop } = this.props;
        return (
        <div className="m-grid m-grid--hor m-grid--root m-page" style={{ minHeight: '100vh'}}>
            <div className="m-grid__item m-grid__item--fluid m-grid m-grid--hor-desktop m-grid--desktop m-body body-background">
            <div className="m-grid__item m-grid__item--fluid  m-grid m-grid--ver	m-container m-container--responsive m-container--xxl m-page__container">
                <div className="m-grid__item m-grid__item--fluid m-wrapper container">
                    <div className="row">
                        <div className="col-xl-4">
                            <div className="m-portlet m-portlet--bordered-semi m-portlet--widget-fit m-portlet--full-height m-portlet--skin-light  m-portlet--rounded-force">
                                <div className="m-portlet__head">
                                    <div className="m-portlet__head-caption">
                                        <div className="m-portlet__head-title">
                                            <h3 className="m-portlet__head-text m--font-light">
                                                Activity
                                            </h3>
                                        </div>
                                    </div>
                                </div>
                                <div className="m-portlet__body">
                                    <div className="m-widget17">                                    
                                       { petShop.dashboard_banner_path ?
                                        <div className="m-widget17__visual m-widget17__visual--chart m-portlet-fit--top m-portlet-fit--sides" style={{backgroundImage: `url(${process.env.REACT_APP_S3_PATH}/${petShop.dashboard_banner_path})`, backgroundSize: 'cover' }}>
                                            <div className="m-widget17__chart" style={{height:'320px'}}><div className="chartjs-size-monitor" style={{position: 'absolute', left: '0px', top: '0px', right: '0px', bottom: '0px', overflow: 'hidden', pointerEvents: 'none', visibility: 'hidden', zIndex: '-1'}}><div className="chartjs-size-monitor-expand" style={{position:'absolute', left:'0', top:'0', right:'0', bottom:'0', overflow:'hidden', pointerEvents:'none', visibility:'hidden',zIndex:'-1'}}><div style={{position:'absolute',width:'1000000px',height:'1000000px',left:'0',top:'0'}}></div></div><div className="chartjs-size-monitor-shrink" style={{position:'absolute',left:'0',top:'0',right:'0',bottom:'0',overflow:'hidden',pointerEvents:'none',visibility:'hidden',zIndex:'-1'}}><div style={{position:'absolute',width:'200%',height:'200%',left:'0',top:'0'}}></div></div></div>
                                                <canvas id="m_chart_activities" width='100%' height='216' className="chartjs-render-monitor" style={{display: 'block', width: '100%', height: '216px'}}></canvas>
                                            </div>
                                        </div>:                                     
                                        <div className="m-widget17__visual m-widget17__visual--chart m-portlet-fit--top m-portlet-fit--sides" style={{backgroundImage: `url(${'assets/app/media/img/pets/pup06.jpg'})`, backgroundSize: 'cover' }}>
                                            <div className="m-widget17__chart" style={{height:'320px'}}><div className="chartjs-size-monitor" style={{position: 'absolute', left: '0px', top: '0px', right: '0px', bottom: '0px', overflow: 'hidden', pointerEvents: 'none', visibility: 'hidden', zIndex: '-1'}}><div className="chartjs-size-monitor-expand" style={{position:'absolute', left:'0', top:'0', right:'0', bottom:'0', overflow:'hidden', pointerEvents:'none', visibility:'hidden',zIndex:'-1'}}><div style={{position:'absolute',width:'1000000px',height:'1000000px',left:'0',top:'0'}}></div></div><div className="chartjs-size-monitor-shrink" style={{position:'absolute',left:'0',top:'0',right:'0',bottom:'0',overflow:'hidden',pointerEvents:'none',visibility:'hidden',zIndex:'-1'}}><div style={{position:'absolute',width:'200%',height:'200%',left:'0',top:'0'}}></div></div></div>
                                                <canvas id="m_chart_activities" width='100%' height='216' className="chartjs-render-monitor" style={{display: 'block', width: '100%', height: '216px'}}></canvas>
                                            </div>
                                        </div>
                                         }
                                        <div className="m-widget17__stats">
                                            <div className="m-widget17__items m-widget17__items-col1">                                          
                                                <div className="m-widget17__item m-widge17__item_round_border">
                                                    <a onClick={(e)=> this.props.history.push("/medical-records")} className="mouse-pointer">
                                                    <span className="m-widget17__icon">
                                                        <i className="fas fa-paw m--font-brand" style={{fontSize:'4rem'}}></i>
                                                    </span>
                                                    <span className="m-widget17__subtitle f-size-30">
                                                        {mRecCount}
                                                    </span>
                                                    <span className="m-widget17__desc">
                                                        Puppy Records
                                                    </span>
                                                    </a>
                                                </div>                                             
                                                <div className="m-widget17__item m-widge17__item_round_border">
                                                <a onClick={(e)=> this.props.history.push("/treatments/Pending")} className="mouse-pointer">
                                                    <span className="m-widget17__icon">
                                                        <i className="fas fa-medkit m--font-warning" style={{fontSize:'4rem'}}></i>
                                                    </span>
                                                    <span className="m-widget17__subtitle f-size-30">
                                                        {pTreatments}
                                                    </span>
                                                    <span className="m-widget17__desc">
                                                        Pending Treatments
                                                    </span>
                                                </a>
                                                </div>
                                            </div>
                                            <div className="m-widget17__items m-widget17__items-col2">
                                                <div className="m-widget17__item m-widge17__item_round_border">
                                                <a onClick={(e)=> this.props.history.push("/contracts")} className="mouse-pointer">
                                                    <span className="m-widget17__icon">                                                    
                                                        <i className="fas fa-briefcase m--font-success" style={{fontSize:'4rem'}}></i>
                                                    </span>
                                                    <span className="m-widget17__subtitle f-size-30">
                                                        {contCount}
                                                    </span>
                                                    <span className="m-widget17__desc"> 
                                                        Contracts
                                                    </span>
                                                 </a>
                                                </div>
                                                <div className="m-widget17__item m-widge17__item_round_border">
                                                <a onClick={(e)=> this.props.history.push("/treatments/InProgress")} className="mouse-pointer">
                                                    <span className="m-widget17__icon">
                                                    
                                                        <i className="fas fa-medkit m--font-info" style={{fontSize:'4rem'}}></i>
                                                    </span>
                                                    <span className="m-widget17__subtitle f-size-30">
                                                        {oTreatments}
                                                    </span>
                                                    <span className="m-widget17__desc">
                                                        Ongoing Treatments
                                                    </span>
                                                    </a>
                                                </div> 
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>                
                       <div className="col-xl-4 col-md-12">
                            <div className="m-portlet m-portlet--bordered-semi m-portlet--full-height">
                                <div className="m-portlet__head">                      
                                  <div className="m-portlet__head-caption">
                                    <div className="m-portlet__head-title">
                                       <h3 className="m-portlet__head-text">
                                        Sales
                                       </h3>
                                    </div>                          
                                  </div>
                                   <div style={{width: "48%", margin: "0", marginTop: "10px"}}>                                                                                         
                                        <Select
                                          options={this.state.salesSelectOption}                                             
                                          value ={this.state.saleSelectedOption}                                      
                                          name="selectOption"
                                          onChange={this.changeSalesOption}
                                          placeholder="Select Sales Filter"                                  
                                        />                                                                 
                                   </div>                                 
                                </div>
                                <div className="m-portlet__body">
                                    <div className="m-widget29">                                                               
                                        <div className="m-widget14__chart">
                                        { !monthlyDataLoading ?
                                        <BarChart data={chartmonthlyData} options={chartOptions} width="352" height="120" redraw/>:
                                        <div className={"loader-center"}>
                                        <Loader type="line-scale" active={true} size={25}/>                                       
                                        </div>
                                        }
                                        </div>
                                        <div className="m-widget1__item">
                                            <div className="m-widget_content">
                                                <h3 className="m-widget_content-title">Income of&nbsp;{saleTitle}</h3>
                                                { !monthlyDataLoading ?
                                                <div className="m-widget_content-items">
                                                    <div className="m-widget_content-item">
                                                        <span>Total</span>                                                  
                                                        <span className="m--font-accent">${this.formatCash(monthlyTotal)}</span>
                                                    </div>                                            
                                                    <div className="m-widget_content-item">
                                                        <span>Count</span>
                                                        <span>{parseInt(monthlyCount)}</span>
                                                    </div>
                                                    <div className="m-widget_content-item">                                                  
                                                        <button
                                                          type="button"                                                    
                                                          className="btn btn-primary m-btn--pill btn-sm" 
                                                          style={{ float: "right" }}                                                        
                                                          onClick={()=>$("#sale_more_details").modal('show')}                                                                                                               
                                                        >                                                                                          
                                                          <span>More Details</span>                                                  
                                                        </button>                                                      
                                                    </div>
                                                </div>:
                                                     <div className={"loader-center"}>
                                                     <Loader type="line-scale" active={true} size={25}/>                                       
                                                     </div>
                                                }
                                            </div>
                                        </div>                                    
                                        <div className="m-widget1__item">
                                            <div className="m-widget_content">
                                              <div className='row mb-3'>
                                                <div className='col-6'>
                                                  <h3 className="m-widget_content-title mt-2">Sales Count</h3>
                                                </div>
                                                <div className='col-6'>                                                                                                                                 
                                                    <Select
                                                        options={this.state.customersStatesTableSelectOptions}                                             
                                                        value ={this.state.customerSelectOption}                                      
                                                        name="customerSelectOption"
                                                        onChange={this.changeCustomersStateSelectOption}     
                                                        placeholder="Select time filter"                                                                                             
                                                    />                                                       
                                                 </div>
                                              </div>                              
                                              <div className="m-widget_content-items mt-2">    
                                                <ToolkitProvider
                                                    keyField="state"
                                                    data={ ContractsViaCustomersState }
                                                    columns={this.tableHeaderColumnData}
                                                    search
                                                    hover={true}
                                                    filter={filterFactory()}
                                                    >
                                                    {props => (
                                                        <div>  
                                                        { !loadingContractViaStateTable ?                                                                    
                                                            <BootstrapTable
                                                            classes="petTable"
                                                            {...props.baseProps}                                                        
                                                            /> :
                                                            <div className={"loader-center"}>
                                                                <Loader
                                                                type="line-scale"
                                                                active={true}
                                                                size={50}                                                                                                               
                                                                />  
                                                            </div>
                                                        }
                                                        { enableMoreText &&
                                                         <div className="px-0 mb-4 search-bar">
                                                            <div className="col-3 px-0 inner-addon right-addon">
                                                                <span><a href="#"  data-toggle="modal" data-target="#full_contracts_view_modal"> Show more..</a></span>                            
                                                            </div>
                                                         </div>  
                                                         }
                                                        </div>
                                                    )}
                                                </ToolkitProvider>                                            
                                               </div>                                     
                                            </div>
                                        </div>                         
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-md-12">							
                            <div className="m-portlet m-portlet--full-height">
                                <div className="m-portlet__head">
                                    <div className="m-portlet__head-caption">
                                        <div className="m-portlet__head-title">
                                            <h3 className="m-portlet__head-text">
                                                Recent Logins
                                            </h3>
                                        </div>
                                    </div>
                                    {/* <div className="m-portlet__head-tools">
                                        <ul className="nav nav-pills nav-pills--brand m-nav-pills--align-right m-nav-pills--btn-pill m-nav-pills--btn-sm" role="tablist">
                                            <li className="nav-item m-tabs__item">
                                                <a className="nav-link m-tabs__link active show" data-toggle="tab" href="#m_widget2_tab1_content" role="tab" aria-selected="true">
                                                    Today
                                                </a>
                                            </li>
                                            <li className="nav-item m-tabs__item">
                                                <a className="nav-link m-tabs__link" data-toggle="tab" href="#m_widget2_tab2_content" role="tab" aria-selected="false">
                                                    Month
                                                </a>
                                            </li>
                                        </ul>
                                    </div> */}
                                </div>
                                <div className="m-portlet__body">
                                    <div className="tab-content">
                                        <div className="tab-pane active" id="m_widget2_tab1_content">
                                            <div className="m-timeline-3">
                                                <div className="m-timeline-3__items ">
                                                    {userLogins.map((u,i)=>(
                                                    <div key={i} className={"m-timeline-3__item border-bottom-dash m-timeline-3__item--"+_.sample(["success","warning","info","danger","brand","primary"])}>
                                                        <span className="m-timeline-3__item-time m-timeline-3__item-time_more"><p >{moment(u.date).format('HH:mm')}<br/><small className="m-timeline-3__item--info_small">{moment(u.date).format('MM-DD-YYYY')}</small></p> 
                                                        </span>
                                                        <div className="m-timeline-3__item-desc">
                                                            <span className="m-timeline-3__item-text">
                                                                {u.User.UserPetstores[0].firstname} {u.User.UserPetstores[0].lastname}
                                                            </span>
                                                            <br/>
                                                            <span className="m-timeline-3__item-user-name">
                                                                <a href="#" className="m-link m-link--metal m-timeline-3__item-link">
                                                                   {u.User.UserPetstores[0].Role.role_name}
                                                                </a>
                                                            </span>
                                                        </div>
                                                    </div>
                                                    ))

                                                    }

                                                </div>
                                            </div>  
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xl-12 ">
                            <div className="m-portlet">
                                <div className="m-portlet__body  m-portlet__body--no-padding">
                                    <div className="row m-row--no-padding m-row--col-separator-xl">
                                        <div className="col-xl-4 col-md-12">
                                            
                                            <div className="m-portlet__head" style={{borderBottom:0}}>
                                                <div className="m-portlet__head-caption">
                                                    <div className="m-portlet__head-title">
                                                        <h3 className="m-portlet__head-text">
                                                            Recent Puppy Records
                                                        </h3>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="m-portlet__body">
                                                <div className="m-widget3">
                                                    <div className="row">
                                                        <div className="col-xl-12">
                                                        {mRecords.map((m,i)=>(                            
                                                            <div className="m-widget3__item" key={i} >
                                                                <div className="m-widget3__header">
                                                                    <div className="m-widget3__user-img">
                                                                        <img className="m-widget3__img" src={process.env.REACT_APP_S3_PATH + '/' + m.avatar_path + '/' + m.avatar_file_name} alt=""/>
                                                                    </div>
                                                                    <div className="m-widget3__info pb-2">
                                                                        <a style={{cursor: "pointer"}} onClick={e=>{this.navigationMR(m)}}>
                                                                        <span className="m-badge m-badge--info px-2"> Pet Id:<strong>{m.pet_id}</strong></span>
                                                                        </a>
                                                                        <br/>
                                                                        <p className="m-widget3__text mb-0">
                                                                            <strong>Breed:</strong> {m.Breed.breed_type}
                                                                        </p>
                                                                        <span className="m-widget3__time">
                                                                            {moment().diff( m.createdAt, 'days')} days ago.
                                                                        </span>
                                                                    </div>
                                                                    <span className={"m-widget3__status pb-2 " + (m.status === 'Draft' ? 'm--font-secondary' : (m.status === 'Available' ? 'm--font-success' : (m.status === 'Sold' ? 'm--font-danger' : '')))}>
                                                                        {m.status}
                                                                    </span>
                                                                    
                                                                </div>
                                                            </div>                                                    
                                                        ))}
                                                                                                                
                                                        </div>
                                                        
                                                    </div>
                                                </div>
                                            </div>
                                            				
                                        </div>
                                        <div className="col-xl-4 col-md-12">
                                        <div className="m-portlet__head" style={{borderBottom:0}}>
                                            <div className="m-portlet__head-caption">
                                                <div className="m-portlet__head-title">
                                                    <h3 className="m-portlet__head-text">
                                                    Recent Contracts
                                                    </h3>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="m-portlet__body">
                                            <div className="m-widget3">
                                                <div className="row">
                                                    <div className="col-xl-12">
                                                        {contracts.map((c,i)=>(                                  
                                                        <NavLink key={i} to={`/contracts/${c.id}`} title="Edit" className='nav-link nav-link_deco'>
                                                            <div className="m-widget3__item" >
                                                                <div className="m-widget3__header" style={{width:'100%'}}>
                                                                    <div className="row">
                                                                        <div className="col-xl-2 col-sm-2 px-0" style={{width:'auto'}}>
                                                                            <div className="m-widget3__user-img">
                                                                                <img className="m-widget3__img ml-1" src={process.env.REACT_APP_S3_PATH + '/' + c.avatar_path + '/' + c.avatar_file_name} alt=""/>
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-xl-4 col-sm-3 px-0" style={{width:'auto'}}>
                                                                            
                                                                            <div className="m-widget3__info pb-2">
                                                                                
                                                                                <span className="m-badge m-badge--info px-2"> Pet Id: <strong>{c.pet_id}</strong></span>
                                                                                <br/>
                                                                                <span className="m-widget3__username">
                                                                                    {c.breed_type} 
                                                                                </span>
                                                                                <br/>
                                                                                <span className="m-widget3__time">
                                                                                {moment(c.date).format('MM-DD-YYYY')}
                                                                                </span>                                                                        
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-xl-6 col-sm-7 px-0" style={{width:'auto'}}>
                                                                            <div className="m-widget3__info pb-2 " style={{float:'right'}}>
                                                                                <h5 className="m--font-danger">  ${c.total}</h5>
                                                                                <span className="m-widget3__username">
                                                                                    {c.cus_firstname} {c.cus_lastname}
                                                                                </span>
                                                                                <br/>
                                                                                <span className="m-widget3__time">
                                                                                    {c.cus_primary}
                                                                                </span>                                                                        
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    
                                                                </div>
                                                            </div>
                                                        </NavLink>
                                                        ))}                                                        
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        </div>
                                        <div className="col-xl-4 col-md-12">
                                            <div className="m-portlet__head" style={{borderBottom:0}}>
                                                <div className="m-portlet__head-caption">
                                                    <div className="m-portlet__head-title">
                                                        <h3 className="m-portlet__head-text">
                                                        Recent Treatments
                                                        </h3>
                                                    </div>
                                                </div>
                                                <div className="m-portlet__head-tools">
                                                    <ul className="nav nav-pills nav-pills--brand m-nav-pills--align-right m-nav-pills--btn-pill m-nav-pills--btn-sm" role="tablist">
                                                        <li className="nav-item m-tabs__item">
                                                            <a className="nav-link m-tabs__link active show" data-toggle="tab" href="#menu11" role="tab" aria-selected="true">
                                                            Ongoing
                                                            </a>
                                                        </li>
                                                        <li className="nav-item m-tabs__item">
                                                            <a className="nav-link m-tabs__link" data-toggle="tab" href="#menu31" role="tab" aria-selected="false">
                                                            Pending
                                                            </a>
                                                        </li>
                                                    </ul>
										        </div>
                                            </div>
                                            <div className="m-portlet__body">
                                                <div className="m-widget28__tab tab-content">
                                                        <div id="menu11" className="m-widget28__tab-container tab-pane active show">
                                                            <div className="m-widget28__tab-items">
                                                                <ul className="list-unstyled mb-0 list-widget">
                                                                    {trmntsOnGoing.length > 0 ? trmntsOnGoing.map((t, i) => (
                                                                        <a href="#" onClick={(e) => {e.preventDefault()}}>
                                                                            <li key={i} onClick={() => this.viewTreatment(t.id)}>
                                                                                <div className="m-widget28__tab-item border-bottom-dash" >
                                                                                    <div className="media mb-4">
                                                                                        <img className="mr-3 rounded-circle m-width-50" src={process.env.REACT_APP_S3_PATH + '/' + t.avatar_path + '/' + t.avatar_file_name} alt=" " />
                                                                                        <div className="media-body list-widget-border">
                                                                                            <div className="float-left">
                                                                                                <h6 className="text-muted "><strong>Breed: </strong>{t.breed}</h6>
                                                                                                <h6 className="text-muted "><strong>Treatment: </strong>{t.calculation_name}</h6>
                                                                                                <span className="text-muted"><strong>Dosage: </strong> {t.dosage}</span>
                                                                                            </div>
                                                                                            <div className='float-right'>
                                                                                                <span className="m-badge m-badge--info px-2">Pet Id: <strong>{t.pet_id}</strong></span>
                                                                                                <p className="text-muted">{t.daysLeft ? t.daysLeft : 0}<small> days remaining</small></p>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </li>
                                                                        </a>
                                                                    )) : <span>No any ongoing treatments.</span>}

                                                                </ul>
                                                            </div>
                                                        </div>
                                                        <div id="menu31" className="m-widget28__tab-container tab-pane fade">
                                                            <div className="m-widget28__tab-items">
                                                                <ul className="list-unstyled mb-0 list-widget">
                                                                    {trmntsPending.length > 0 ? trmntsPending.map((t, i) => (
                                                                        <a href="#" onClick={(e) => { e.preventDefault() }}>
                                                                            <li key={i} onClick={() => this.viewTreatment(t.id)}>
                                                                                <div className="m-widget28__tab-item border-bottom-dash" >
                                                                                    <div className="media mb-4">
                                                                                        <img className="mr-3 rounded-circle m-width-50" src={process.env.REACT_APP_S3_PATH + '/' + t.avatar_path + '/' + t.avatar_file_name} alt=" " />
                                                                                        <div className="media-body list-widget-border">
                                                                                            <div className="float-left">
                                                                                                <h6 className="text-muted "><strong>Breed: </strong>{t.breed}</h6>
                                                                                                <h6 className="text-muted "><strong>Treatment: </strong>{t.calculation_name}</h6>
                                                                                                <span className="text-muted"><strong>Dosage: </strong> {t.dosage}</span>
                                                                                            </div>
                                                                                            <div className='float-right'>
                                                                                                <span className="m-badge m-badge--info px-2">Pet Id: <strong>{t.pet_id}</strong></span>
                                                                                                <p className="text-muted">{t.daysLeft ? t.daysLeft : 0}<small> days remaining</small></p>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </li>
                                                                        </a>
                                                                    )) : <span>No any pending treatments.</span>}
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                    
                        </div>
                    </div>  
                    <div className="row">
                        <div className="col-xl-12" style={{justifyContent:"center"}}>
                            <div className="m-portlet">
                                <div className="m-portlet__body  m-portlet__body--no-padding">
                                    <div className="row m-row--no-padding m-row--col-separator-xl">
                                        <div className="col-xl-12 col-md-12">                                            
                                            <div className="m-portlet__head" style={{borderBottom:0}}>
                                                <div className="m-portlet__head-caption">
                                                    <div className="m-portlet__head-title">
                                                        <div>
                                                        <h3 className="m-portlet__head-text">
                                                         Customer Inquiries for Puppy Records
                                                        </h3>
                                                        </div>
                                                     </div>                                                                                                  
                                                </div>                                        
                                            </div>                                       
                                            <div className="m-portlet__body">
                                                <div className="m-widget3">                                              
                                                    <div className="form-group m-form__group row">                                                      
                                               
                                                        <label className="col-lg-1 col-sm-12 col-form-label cust-inq">
                                                        {" "}
                                                        Pet Id:
                                                        </label>
                                                                                                
                                                    <div className="col-lg-2 cust-inq-pad-left">
                                                    <input
                                                        type="text"
                                                        name="petId"
                                                        onChange={this.changeVal}
                                                        className="form-control m-input"
                                                        placeholder="Enter Pet Id"
                                                        value={petId}
                                                    
                                                    />                                             
                                                   </div>                                                 
                                                   <label className="col-lg-1 col-sm-12 col-form-label cust-inq">
                                                    {" "}
                                                    From:
                                                    </label>
                                                    <div className="col-lg-2 cust-inq-pad-left">
                                                    <Select
                                                        options={verifyEmail}
                                                        value={verifyEmailId}
                                                        name="typeMail"
                                                        onChange={this.changeEmailType}
                                                        placeholder="Select Sending Email"
                                                   />                                           
                                                   </div> 
                                                    <label className="col-lg-1 col-sm-12 col-form-label cust-inq">
                                                    {" "}
                                                    To:
                                                    </label>
                                                    <div className="col-lg-3 cust-inq-pad-left">
                                                    <input
                                                        type="text"
                                                        name="email"
                                                        onChange={this.changeVal}
                                                        className="form-control m-input"
                                                        placeholder="Enter Email Address"
                                                        value={email}                                                    
                                                    />                                           
                                                    </div>    
                                                    <div className="col-lg-2 cust-inq-pad-left">
                                                    <button
                                                        type="button"                                                    
                                                        className="btn btn-primary m-btn--pill" 
                                                        style={{ float: "right" }}  
                                                        onClick={()=>this.sendEmail()}                                                      
                                                    >
                                                        <span>
                                                         <i className="la la-check"></i>
                                                         &nbsp;&nbsp;
                                                          <span>Submit</span>
                                                        </span>
                                                    </button>                                           
                                                   </div>                                                                                                                                                     
                                                </div>                                         
                                        
                                                </div>
                                            </div>                                                    
                               
                                        </div>                             
                                        
                                    </div>
                                </div>
                            </div>
                    
                        </div>
                    </div>                      
                    <ViewTreatment treatmentId={treatId} />
                    <div
                      className="modal fade show"
                      id="full_contracts_view_modal"
                      tabIndex="-1"
                      role="dialog"
                    >
                        <div className="modal-dialog" role="document">
                            <div className="modal-content">
                                <form className="m-form">
                                <div className="modal-header">
                                    <h5 className="modal-title" id="exampleModalLabel">
                                       Sales Count By State
                                    </h5>
                                    <button
                                    type="button"
                                    className="close"
                                    data-dismiss="modal"
                                    aria-label="Close"
                                    >
                                    <span aria-hidden="true">×</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <div className="row">
                                        <div className="col-xl-12">
                                          <ToolkitProvider
                                             keyField="state"
                                             data={ ContractsAllDataViaCustomersState }
                                             columns={this.tableHeaderColumnData}
                                             search
                                             hover={true}
                                             filter={filterFactory()}
                                          >
                                            {props => (
                                             <div>                                                              
                                               <BootstrapTable
                                                 classes="petTable"
                                                 {...props.baseProps}                                                        
                                                />  
                                             </div>
                                                )}
                                          </ToolkitProvider>
                                        </div>
                                    </div>
                                </div>  
                                </form>
                            </div>
                        </div>
                    </div>
                    {/* more details start */}
                    <div
                     className="modal fade show"
                     id="sale_more_details"
                     tabIndex="-1"
                     role="dialog"
                     >
                      <div className="modal-dialog" role="document">
                       <div className="modal-content">
                        <form className="m-form">
                            <div className="modal-header">
                                <h5 className="modal-title" id="exampleModalLabel">
                                Sale More Details
                                </h5>
                                <button
                                type="button"
                                className="close"
                                data-dismiss="modal"
                                aria-label="Close"
                                >
                                <span aria-hidden="true">×</span>
                                </button>
                            </div>
                            <div className="modal-body">
                              <div className="row justify-content-center">
                               <div className="col-8">
                                    <div className="m-form__section m-form__section--first">      

                                    <div className="form-group m-form__group row">
                                        <label className="col-6 col-6">
                                          Cash :
                                        </label>
                                        <div className="col-6 col-6">
                                        <strong> <span>${parseFloat(monthlyCashTotal).toFixed(2)}</span> </strong>  
                                        </div>
                                    </div>

                                    <div className="form-group m-form__group row">
                                        <label className="col-6 col-6">
                                          Credit/Debit :
                                        </label>
                                        <div className="col-6 col-6">                              
                                         <strong> <span>${parseFloat(monthlyCDTotal).toFixed(2)}</span> </strong>
                                        </div>                                       
                                    </div>

                                    <div className="form-group m-form__group row">
                                        <label className="col-6 col-6">
                                         Financing :
                                        </label>
                                        <div className="col-6 col-6">
                                          <strong><span>${parseFloat(monthlyFinanceTotal).toFixed(2)}</span></strong>
                                        </div>                                       
                                    </div>

                                    
                                    <div className="form-group m-form__group row">
                                        <label className="col-6 col-6">
                                         Tax :
                                        </label>
                                        <div className="col-6 col-6">
                                          <strong><span>${parseFloat(monthlyTax).toFixed(2)}</span></strong>
                                        </div>                                       
                                    </div>

                                    <div className="form-group m-form__group row">
                                        <label className="col-6 col-6">
                                         Total :
                                        </label>
                                        <div className="col-6 col-6">
                                         <strong> <span>${parseFloat(monthlyTotal).toFixed(2)}</span>  </strong>  
                                        </div>                                       
                                    </div>
                                
                                    </div>
                               </div>
                              </div>
                            </div>                      
                        </form>
                       </div>
                      </div>
                     </div>
                    {/* more details end */}
            </div>
        </div>
    </div>
    </div>

        )
    }
}

const mapStateToProps = state => ({
  user: state.cognito.user,
  treatments:state.addFormulaReducer.treatment,
  mRecords:state.medicalRecordsReducer.mRecords,
  contracts:state.contractsReducer.contracts,
  mRecordCount:state.medicalRecordsReducer.totalMRecords,
  contractCount:state.contractsReducer.conCount,
  pendingTreatments:state.addFormulaReducer.pendingTreatCount,
  ongoingTreatments:state.addFormulaReducer.ongoingTreatCount,
  contractInfo:state.contractsReducer.contractInfo,
  userLogins:state.userReducer.userLogins,

  treatmentError:state.addFormulaReducer.treatmentError,
  mRecordsError:state.medicalRecordsReducer.mRecordsError,
  mRecordCountError:state.medicalRecordsReducer.mRecordCountError,
  contractCountError:state.contractsReducer.contractCountError,
  ongoingTreatCountError:state.addFormulaReducer.ongoingTreatCountError,
  pendingTreatCountError:state.addFormulaReducer.pendingTreatCountError,
  contractsError:state.contractsReducer.contractsError,
  conCountError:state.contractsReducer.conCountError,
  contractInfoError:state.contractsReducer.contractInfoError,
  userLoginsError:state.userReducer.userLoginsError,
  customerEmail:state.customersReducer.email,
  customerEmailErr:state.customersReducer.emailSendError,
  verifyEmailList: state.customersReducer.emailList,
  contractLastWeekInfo:state.contractsReducer.contractLastWeekInfo,
  contractLastMonthInfo:state.contractsReducer.contractLastMonthInfo,
  contractLastMonthInfoError:state.contractsReducer.contractLastMonthInfoError,
  contractLastWeekInfoError:state.contractsReducer.contractLastWeekInfoError,
  contractsViaCustomerState: state.contractsReducer.contractsViaCustomerState,
  contractsViaCustomerStateError :  state.contractsReducer.contractsViaCustomerStateError,  
  petShop: state.petShopReducer.currentPetshop,  


});
const mapDispatchToProps = dispatch => ({ 
    getOngoingTreatmentsCount:()=>{
        dispatch(getOngoingTreatmentsCount());
    },
    getPendingTreatmentsCount:()=>{
        dispatch(getPendingTreatmentsCount());
    },
    fetchTreatments: () => {
        dispatch(fetchTreatments());
    },
    fetchMedicalRecords: () => {
        dispatch(fetchMedicalRecords());
    },
    fetchContracts:() => {
        dispatch(fetchContracts());
    },
    getTotalMedicalRecordsCount:()=>{
        dispatch(getTotalMedicalRecordsCount());
    },
    getTotalContractCount:()=>{
        dispatch(getTotalContractCount());
    },
    getCurrentYearContractsInfo:()=>{
        dispatch(getCurrentYearContractsInfo());
    },
    fetchUserLogins:()=>{
        dispatch(fetchUserLogins());
    },
    sendEmailCustomer:(data)=>{
        dispatch(sendEmailCustomer(data));
    },
    fetchVerifyEmail:()=>{
        dispatch(fetchVerifyEmail());
    },
    getLastWeekContractsInfo:()=>{
        dispatch(getLastWeekContractsInfo());
    },
    getMonthlyContractInfo:(startDate)=>{
        dispatch(getMonthlyContractInfo(startDate));
    },
    getContractsViaCustomerState:(filterType)=>{
        dispatch(getContractsViaCustomerState(filterType));
    },
    getCurrentPetShop: t => {
        dispatch(getCurrentPetShop(t));
    }
    
});


export default withRouter(connect(mapStateToProps,mapDispatchToProps)(AdminDashboard));
